export const ownerSteps = [
  { id: 1, label: "Community Info" },
  { id: 2, label: "Approval Info" },
];

export const BomSteps = [
  { id: 1, label: "Community Info" },
  { id: 2, label: "License Info" },
  { id: 3, label: "Financial Info" },
  { id: 4, label: "Approval Info" },
];
